import type { AppVariantConfig } from '@shared/app/variant';
import { nb } from '@oslo/i18n/nb';
import { en } from './i18n/en';

export const englishVariantConfig: AppVariantConfig = {
  variant: 'english',
  locale: en.meta.locale,
  messages: en,
  fallbackMessages: nb,
  themeClassName: 'theme-english',
};
